<!--
  Ported from vendor-ref/mara/app/ui/src/components/GlobalDropzone.vue:103-136, 174-191: drag-and-drop anywhere
  shows the blurred overlay; dropped files are loaded straight away (MARA's options dialog is server-only).
-->
<script setup lang="ts">
import { ref } from 'vue';
import { useDropZone, useEventListener } from '@vueuse/core';
import { isSupportedFileName, useLiteStore } from '@nanome-lite/state';

const store = useLiteStore();
const upload = ref<HTMLElement | null>(null);
const showDropZone = ref(false);
let count = 0;

async function load(files: File[]) {
  const supported = files.filter(f => isSupportedFileName(f.name));
  for (const f of files) if (!supported.includes(f)) store.toast('warn', 'Unsupported file', f.name);
  if (supported.length) await store.addEntryFromFiles(supported);
}

const { isOverDropZone } = useDropZone(upload, { onDrop: (files) => { showDropZone.value = false; if (files) load(files); } });

useEventListener(document.body, 'dragenter', (e: DragEvent) => {
  count += 1;
  showDropZone.value = !!e.dataTransfer?.types.includes('Files');
});
useEventListener(document.body, 'dragleave', () => {
  count -= 1;
  if (count <= 0) { count = 0; showDropZone.value = false; }
});
useEventListener(document.body, 'dragover', (e: DragEvent) => {
  if (e.dataTransfer?.types?.includes('Files')) e.preventDefault();
});
useEventListener(document.body, 'drop', (e: DragEvent) => {
  count = 0;
  showDropZone.value = false;
  if (e.defaultPrevented) return;
  const dropped = Array.from(e.dataTransfer?.files ?? []);
  if (!dropped.length) return;
  e.preventDefault();
  load(dropped);
});
</script>

<template>
  <div v-if="showDropZone" class="z-100 fixed top-0 left-0 w-full h-full flex backdrop-blur" style="background: var(--mask-background);">
    <div
      ref="upload"
      :class="isOverDropZone ? 'b-primary' : 'b-section'"
      class="m-2 p-4 grow-1 flex items-center justify-center b-2 b-dashed rd-5"
    >
      <div class="p-6 text-center backdrop-blur b-1 b-solid b-section bg-content bg-op-25 rd-5">
        <i class="i-tabler-upload mb-2 text-3xl" />
        <div class="op-50">
          Drop files to load
        </div>
      </div>
    </div>
  </div>
</template>
